import { RECEIVE_DEVICES, REQUEST_DEVICES } from "./types";
import * as sessionTypes from "../session/types";

export const INITIAL_STATE = {
    fetchStatus: "loading",
    devices: null,
    lastUpdate: null
};

function devices(state = INITIAL_STATE, action) {
    switch (action.type) {
        case sessionTypes.RESET_AUTH:
            return INITIAL_STATE;

        case REQUEST_DEVICES:
            return INITIAL_STATE;

        case RECEIVE_DEVICES:
            return {
                devices: action.devices,
                fetchStatus: "loaded",
                lastUpdate: action.recievedAt
            };

        default:
            return state;
    }
}

export default devices;



// WEBPACK FOOTER //
// ./src/modules/devices/reducers.js